module.exports = __webpack_public_path__ + "media/styles/images/svg/select-gray-dark-1e8866aebc4a6e50746a1852b07af38b.svg";